import { render, staticRenderFns } from "./ContractTab.vue?vue&type=template&id=47bd59ca&scoped=true&"
import script from "./ContractTab.vue?vue&type=script&lang=js&"
export * from "./ContractTab.vue?vue&type=script&lang=js&"
import style0 from "./ContractTab.vue?vue&type=style&index=0&id=47bd59ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bd59ca",
  null
  
)

export default component.exports